export default __webpack_public_path__ + "static/media/torq.84e31e5b.svg";